import * as type from "../types";
import { topEco, worstEco } from "../../utils/staticData";

const initialAverageMilage = {
    tydzien: {przebieg: 0, przebieg_procent: ""},
    miesiac: {przebieg: 0, przebieg_procent: ""},
    kwartal: {przebieg: 0, przebieg_procent: ""}
};

const initialTotalDriveTime = {
    tydzien: {czas: 0, czas_procent: ""},
    miesiac: {czas: 0, czas_procent: ""},
    kwartal: {czas: 0, czas_procent: ""}
};

const initialFuelUsage = {
    tydzien: {spalanie: 0, spalanie_procent: ""},
    miesiac: {spalanie: 0, spalanie_procent: ""},
    kwartal: {spalanie: 0, spalanie_procent: ""}
};

const initialEcoRoutesValues = {
    eco_niskie: {eco: '0', eco_procent: '0%'},
    eco_srednie: {eco: '0', eco_procent: '0%'},
    eco_wysokie: {eco: '0', eco_procent: '0%'}
};

const initialState = {
    averageMileage: initialAverageMilage,
    fuelUsage: initialFuelUsage,
    ecoRoutesValues: initialEcoRoutesValues,
    totalDriveTime: initialTotalDriveTime,
    privateDriveTime: {czas: 0},
    inServiceList: {},
    ecoGrade: {ocena: ""},
    ecoCars: {[topEco]: {rejestracja: "", ocena: ""}, [worstEco]: {rejestracja: "", ocena: ""}},
    ecoDrivers: {[topEco]: {kierowca: "", ocena: ""}, [worstEco]: {kierowca: "", ocena: ""}},
    topTrophyList: {kierowcy: []},
    alerts: []
};

export default function (state = initialState, action) {
    switch (action.type) {
        case type.GET_DISTANCE:
            return {
                ...state,
                averageMileage: action.value
            };
        case type.GET_FUEL_USAGE:
            return {
                ...state,
                fuelUsage: action.value
            };
        case type.GET_ECO_ROUTES:
            return {
                ...state,
                ecoRoutesValues: action.value
            };
        case type.GET_TOTAL_DRIVE_TIME:
            return {
                ...state,
                totalDriveTime: action.value
            };
        case type.GET_PRIVATE_DRIVE_TIME:
            return {
                ...state,
                privateDriveTime: action.value
            };
        case type.GET_CARS_IN_SERVICE:
            return {
                ...state,
                inServiceList: action.value
            };
        case type.GET_ECO_GRADE:
            return {
                ...state,
                ecoGrade: action.value
            };
        case type.GET_ECO_CARS:
            return {
                ...state,
                ecoCars: action.value
            };
        case type.GET_ECO_DRIVERS:
            return {
                ...state,
                ecoDrivers: action.value
            };
        case type.GET_ALERTS:
            return {
                ...state,
                alerts: action.value
            };
        case type.GET_TOP_TROPHY_LIST:
            return {
                ...state,
                topTrophyList: action.value
            };
        default:
            return state;
    }
}
